import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dashboard from './dashboard';
import { extractNameHours } from './utils';
import firebaseApp from '../../firebase/firebase';

export default class DashboardContainer extends Component {
  constructor(){
    super()
    this.state = ({
      realtors: null
    })
  }

  componentDidMount() {
    firebaseApp.database().ref(`users`).on('value', snapshot => {
      let realtors = snapshot.val()
      realtors = extractNameHours(realtors);
      this.setState({ realtors })
    })
  }

  render() {
    if (this.state.realtors !== null) {
      return (
        <Dashboard realtors={this.state.realtors}/>
       )
    }
    return (
      <div>
        Loading...
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardContainer.js